import type { TranslationDictionary } from "./types";

export const ZH_CN_DICTIONARY: TranslationDictionary = {
    "app.newTask": "新建",
    "app.newTaskAria": "新建对话",
    "sidebar.searchPlaceholder": "搜索提示词或任务 ID",
    "sidebar.filters": "任务筛选",
    "sidebar.allRatios": "全部比例",
    "sidebar.allOrientations": "全部方向",
    "sidebar.allModes": "全部模式",
    "sidebar.allResolutions": "全部分辨率",
    "sidebar.allStatuses": "全部状态",
    "sidebar.activeTasks": "活动任务",
    "sidebar.topAnchors": "顶部时间导航",
    "sidebar.bottomAnchors": "底部时间导航",
    "sidebar.resize": "调整侧栏宽度",
    "batch.selected": "已选择 0 个",
    "batch.selectedCount": "已选择 {count} 个",
    "batch.selectCurrentGroup": "全选本组",
    "batch.archivedCount": "已归档 {count} 个会话",
    "batch.archiveFailed": "批量归档失败",
    "batch.runningCannotDeleteSelected": "选中的会话正在运行，不能删除",
    "batch.deleteTitle": "删除 {count} 个会话？",
    "batch.deleteMessage": "会同时删除本地图片文件。",
    "batch.deleteSkippedDetail": "{count} 个运行中任务会保留",
    "batch.deleteSkippedSuffix": "，{count} 个运行中未删除",
    "batch.deletedCount": "已删除 {count} 个会话{skipped}",
    "batch.deleteFailed": "批量删除失败",
    "batch.cancelTasksShortcut": "批量取消",
    "batch.cancelSelected": "取消任务",
    "batch.noActiveSelected": "选中的任务已不在运行或等待队列中",
    "batch.cancelTitle": "取消 {count} 个任务？",
    "batch.cancelMessage": "运行中的任务会停止，等待中的任务会离开队列；历史记录都会保留。",
    "batch.cancelDetail": "运行 {running} 个 · 等待 {waiting} 个",
    "batch.cancelConfirm": "确认取消",
    "batch.cancelResult": "已取消 {cancelled} 个，跳过 {skipped} 个，失败 {failed} 个",
    "batch.cancelFailed": "批量取消失败",
    "action.archive": "归档",
    "action.delete": "删除",
    "action.cancel": "取消",
    "action.edit": "编辑",
    "action.clear": "清空",
    "action.paste": "粘贴",
    "action.find": "查找",
    "action.replace": "替换",
    "action.close": "关闭",
    "action.confirm": "确认",
    "action.confirmQuestion": "确认操作？",
    "action.refresh": "↻ 刷新",
    "action.save": "保存",
    "action.add": "添加",
    "action.new": "新建",
    "action.import": "导入",
    "action.export": "导出",
    "queue.empty": "暂无排队",
    "queue.emptyAria": "队列状态：暂无排队",
    "queue.jumpTitle": "跳转到进行中任务",
    "queue.emptyTitle": "暂无排队任务",
    "queue.channel": "通道 {count}",
    "queue.availableChannels": "可用通道 {usable}/{total}",
    "queue.dispatching": "调度中 · 等待 {waiting}",
    "queue.runningWaiting": "运行 {running} · 等待 {waiting}",
    "queue.statusLabel": "队列状态：{text} · {channelText}。点击跳转到进行中任务",
    "queue.runningActions": "运行任务队列操作",
    "queue.waitingActions": "等待任务队列操作",
    "queue.cancelRunning": "取消",
    "queue.cancelRunningTitle": "取消运行任务",
    "queue.dragWaiting": "拖动调整等待顺序",
    "queue.dragSort": "拖动排序",
    "queue.moveUp": "上",
    "queue.moveUpTitle": "上移等待任务",
    "queue.moveDown": "下",
    "queue.moveDownTitle": "下移等待任务",
    "queue.promote": "顶",
    "queue.promoteTitle": "置顶等待任务",
    "queue.promoteFailed": "置顶失败",
    "queue.deleteWaitingShort": "删",
    "queue.deleteWaitingTitle": "删除等待任务",
    "queue.deleteWaitingTitleConfirm": "删除等待任务？",
    "queue.deleteWaitingMessage": "会从队列和历史列表中移除。",
    "queue.deleteQueuedFailed": "删除队列任务失败",
    "queue.queuedDeleted": "队列任务已删除",
    "queue.cancelRunningConfirm": "取消任务",
    "queue.cancelRunningTitleConfirm": "取消运行任务？",
    "queue.cancelRunningMessage": "当前任务会停止，历史记录会保留。",
    "queue.cancelRunningFailed": "取消任务失败",
    "queue.runningCancelled": "任务已取消",
    "queue.reorderFailed": "队列排序失败",
    "queue.realtimeUpdateFailed": "实时状态更新失败",
    "queue.realtimeDisconnected": "实时状态连接已断开，刷新页面可恢复",
    "queue.readFailed": "队列读取失败",
    "status.waiting": "等待任务",
    "status.shownActiveTasks": "已显示进行中任务",
    "status.jsonCopied": "JSON 已复制",
    "taskStatus.submitting": "提交中",
    "taskStatus.running": "生成中",
    "taskStatus.runningWithElapsed": "生成中 · {elapsed}",
    "taskStatus.completed": "已完成",
    "taskStatus.partialFailed": "部分失败",
    "taskStatus.failed": "失败",
    "taskStatus.queued": "排队中",
    "taskStatus.unknown": "未知状态",
    "taskStatus.task": "任务",
    "taskStatus.connectionInterrupted": "连接中断",
    "taskStatus.lastFailed": "上次失败",
    "taskStatus.waitingRetry": "{reason}，等待重试（第 {attempt}/{max} 次尝试）",
    "taskStatus.retrying": "{reason}，重试中（第 {attempt}/{max} 次尝试）",
    "taskStatus.nonRetryableAttempt": "第 {attempt}/{max} 次，不可重试",
    "taskStatus.manualRetryAvailable": "已停止，可手动重试失败图片",
    "taskStatus.waitingRetryShort": "等待重试",
    "taskStatus.retryingShort": "重试中",
    "taskStatus.nonRetryableShort": "不可重试",
    "taskStatus.manualRetryShort": "可手动重试",
    "taskStatus.stoppedShort": "已停止",
    "taskStatus.runtime": "耗时 {duration}",
    "taskStatus.runtimeCompleted": "耗时 {duration} · 完成 {time}",
    "taskStatus.completedAt": "完成 {time}",
    "taskCard.count": "{count} 张",
    "taskCard.successCount": "成功 {count}",
    "taskCard.failedCount": "失败 {count}",
    "taskCard.runningCount": "生成中 {count}",
    "taskCard.waitingCount": "等待 {count}",
    "taskCard.textToImageThumb": "文生图任务缩略图",
    "taskCard.imageToImageThumb": "图生图任务缩略图",
    "taskCard.failedThumb": "任务失败",
    "taskCard.textBadge": "文",
    "taskMode.edit": "编辑",
    "taskMode.generate": "生成",
    "document.generatingQueue": "生成中 · 队列 {total}",
    "document.queuedWaiting": "排队中 · 等待 {count}",
    "runFeedback.editing": "编辑中",
    "runFeedback.generating": "生成中",
    "runFeedback.status": "{action}，计时 {elapsed}",
    "footer.archive": "会话归档",
    "footer.archiveCount": "会话归档 {count}",
    "footer.historyLibrary": "历史库",
    "historyLibrary.openFull": "打开完整历史库",
    "history.documentTitle": "历史库 - iLab CONJURE",
    "history.back": "返回生成页",
    "history.homeAria": "返回 iLab CONJURE 生成页",
    "history.backToGenerator": "返回生成页",
    "history.title": "历史库",
    "history.loading": "载入中",
    "history.total": "{total} 个任务 · {archived} 已归档",
    "history.search": "搜索",
    "history.searchPlaceholder": "搜索提示词或任务 ID",
    "history.clear": "清空",
    "history.favorites": "收藏",
    "history.onlyFavorites": "仅看收藏",
    "history.favoriteTask": "收藏任务",
    "history.unfavoriteTask": "取消收藏",
    "history.tags": "标签",
    "history.untagged": "无标签",
    "history.manageTags": "管理标签",
    "history.createTag": "创建标签",
    "history.renameTag": "改名",
    "history.deleteTag": "删除",
    "history.deleteTagAffected": "删除（影响 {count} 个任务）",
    "history.addTag": "添加标签",
    "history.removeTag": "移除标签",
    "history.favoriteSelected": "收藏",
    "history.unfavoriteSelected": "取消收藏",
    "history.organizationFailed": "收藏或标签更新失败",
    "history.tagNameConflict": "这个标签名称已存在",
    "history.noTags": "还没有标签",
    "history.backendRestartRequired": "历史库功能已更新，请重启应用后再试",
    "history.export": "导出",
    "history.exportImagesOnly": "仅图片",
    "history.exportImagesWithPrompts": "图片＋提示词",
    "history.exportPreparing": "正在准备导出…",
    "history.exportStarted": "已开始下载",
    "history.exportSummary": "{taskCount} 个任务 · {imageCount} 张图片",
    "history.exportFailed": "导出失败",
    "history.closeExport": "关闭导出选择",
    "history.type": "类型",
    "history.allTypes": "全部类型",
    "history.type.textToImage": "文生图",
    "history.type.imageToImage": "图生图",
    "history.month": "月份",
    "history.status": "状态",
    "history.promptMode": "提示词处理",
    "history.size": "尺寸",
    "history.quality": "质量",
    "history.ratio": "比例",
    "history.orientation": "方向",
    "history.backend": "后端",
    "history.provider": "供应商",
    "history.archived": "归档",
    "history.all": "全部",
    "history.allMonths": "全部月份",
    "history.allStatuses": "全部状态",
    "history.allPromptModes": "全部模式",
    "history.allSizes": "全部尺寸",
    "history.allQualities": "全部质量",
    "history.allRatios": "全部比例",
    "history.ratioOther": "其他",
    "history.allOrientations": "全部方向",
    "history.allBackends": "全部后端",
    "history.allProviders": "全部供应商",
    "history.unarchived": "未归档",
    "history.archivedOnly": "已归档",
    "history.tasksAria": "历史任务",
    "history.taskListTitle": "历史任务",
    "history.browseNewest": "按时间倒序浏览",
    "history.view": "视图",
    "history.grid": "网格",
    "history.list": "列表",
    "history.sort": "排序",
    "history.newest": "最新优先",
    "history.oldest": "最早优先",
    "history.refresh": "刷新",
    "history.selectedCount": "已选择 {count} 个任务",
    "history.confirmDelete": "确认删除",
    "history.detail": "任务详情",
    "history.detailTitle": "历史任务",
    "history.closeDetail": "关闭任务详情",
    "history.resizeFilters": "调整筛选栏宽度",
    "history.resizeDetail": "调整详情栏宽度",
    "history.detailEmpty": "选择一个历史任务查看详情",
    "history.loadingDetail": "载入详情...",
    "history.loadMore": "继续载入",
    "history.loadingMore": "载入中...",
    "history.noMore": "没有更多任务",
    "history.loadFailed": "载入失败，刷新或继续滚动重试",
    "history.summaryFailed": "摘要载入失败",
    "history.tasksFailed": "历史任务载入失败",
    "history.detailFailed": "详情载入失败",
    "history.noMatches": "暂无匹配任务",
    "history.loadedCount": "{count} 条已载入",
    "history.windowNotice": "列表窗口已限制为 {count} 条；上下滚动会按需恢复相邻任务",
    "history.selectTask": "选择任务",
    "history.viewing": "查看中",
    "history.noPreview": "暂无可预览图片",
    "history.downloadAll": "打包下载",
    "history.downloadImage": "下载图片",
    "history.downloadSelected": "下载精选",
    "history.deleteUnselected": "删除未精选",
    "history.confirmDeleteUnselected": "确认删除未精选",
    "history.selected": "已精选",
    "history.select": "精选",
    "history.downloadIndex": "下载 {index}",
    "history.addReference": "加入参考图",
    "history.outputActions": "结果图操作",
    "history.inputReferences": "输入参考图",
    "history.inputReferenceIndex": "输入参考图 {index}",
    "history.copyPrompt": "复制提示词",
    "history.copyPrompts": "复制提示词",
    "history.copyPromptShort": "复制",
    "history.copyPromptPanel": "复制{title}",
    "history.copyOutputPromptPanel": "复制图 {index} 优化提示词",
    "history.copyTaskIds": "复制任务 ID",
    "history.reuseTask": "生成页查看",
    "history.downloadTask": "下载",
    "history.downloadSelectedTasks": "批量下载",
    "history.contextMenuLabel": "历史任务右键菜单",
    "history.promptCopied": "提示词已复制",
    "history.promptsCopied": "已复制 {count} 个任务的提示词",
    "history.taskIdsCopied": "已复制 {count} 个任务 ID",
    "history.promptCopiedShort": "已复制",
    "history.promptCopyFailed": "复制提示词失败",
    "history.promptCopyFailedShort": "失败",
    "history.noPrompt": "这个任务没有可复制的提示词",
    "history.noPromptShort": "无内容",
    "history.downloadStarted": "已开始下载",
    "history.batchDownloadStarted": "已开始下载 {count} 个任务",
    "history.noDownloadableOutputs": "没有可下载图片",
    "history.confirmDeleteSelected": "确认删除已选",
    "history.openPreview": "放大预览",
    "history.closePreview": "关闭预览",
    "history.untitled": "Untitled",
    "history.promptCompare": "提示词对比",
    "history.promptOriginal": "原始提示词",
    "history.promptSubmitted": "优化提示词",
    "history.promptRevised": "优化结果",
    "history.outputRevisedPromptTitle": "图 {index} 优化提示词",
    "history.outputRevisedPromptNotice": "每张图的优化提示词不同，见对应图片下方。",
    "history.promptEmpty": "暂无内容",
    "history.promptMode.strict": "保真",
    "history.promptMode.original": "原文",
    "history.promptMode.off": "自动",
    "history.quality.high": "高",
    "history.quality.medium": "中",
    "history.quality.low": "低",
    "history.quality.auto": "自动",
    "footer.batch": "批量管理",
    "footer.storage": "存储设置",
    "footer.apiStatus": "API 状态: 正常",
    "footer.version": "版本 {version}",
    "footer.versionInfo": "版本信息",
    "footer.versionLoading": "版本 ...",
    "footer.updateBadge": "有新版本",
    "footer.updateAvailable": "有新版本 {version}",
    "version.title": "版本与更新",
    "version.loading": "正在读取版本状态",
    "version.current": "当前版本",
    "version.latest": "最新版本",
    "version.source": "运行方式",
    "version.sourcePortable": "一键包",
    "version.sourceStandard": "标准 App",
    "version.sourceSource": "源码运行",
    "version.upToDate": "当前已经是最新版",
    "version.updateAvailable": "发现新版本 {version}。关闭 WebUI 服务窗口后运行更新器即可升级。",
    "version.standardUpdateAvailable": "发现新版本 {version}。包含更新助手的 macOS 标准 App 可从菜单栏“检查更新”一键安装；这里保留手动下载入口。",
    "version.standardManualInstall": "macOS 标准 App 在更新助手可用时支持用户确认后自动覆盖；旧版 macOS App 和 Windows 标准 ZIP 仍需手动替换。",
    "version.noUpdater": "当前不是一键包运行，不能自动启动更新器。",
    "version.openUpdater": "启动更新器",
    "version.release": "查看发布页",
    "version.updaterStarted": "更新器已启动。请关闭当前 WebUI 服务窗口，再按更新器提示操作。",
    "version.updaterFailed": "启动更新器失败，请手动运行包内更新脚本。",
    "version.onboardingTitle": "0.5.5 新增标准应用包",
    "version.onboardingStatus": "你已升级到 {version}。现在可以继续使用便携版，也可以改用标准应用包。",
    "version.onboardingBody": "这次更新新增了 macOS DMG 和 Windows App ZIP。新用户建议使用标准包；当前便携包仍可继续使用。",
    "version.onboardingDataPortable": "当前数据已保留在这个便携包的 data/ 目录。",
    "version.onboardingStandardData": "标准 App 会把数据放到系统应用数据目录：macOS Application Support / Windows %APPDATA%。",
    "version.onboardingMigration": "切换标准 App 时请使用迁移助手复制旧数据，不会移动或覆盖原数据。",
    "version.standardDownload": "下载标准版",
    "version.continuePortable": "继续使用便携版",
    "version.dismissOnboarding": "不再提示",
    "version.dismissFailed": "无法保存提示状态，请稍后再试。",
    "notifications.title": "任务通知",
    "notifications.unread": "任务通知，{count} 条未读",
    "notifications.unreadSummary": "{count} 未读",
    "notifications.empty": "暂无任务通知",
    "notifications.taskFailed": "任务失败",
    "notifications.taskPartial": "任务部分完成",
    "notifications.taskCompleted": "任务已完成",
    "notifications.generationFailed": "生成失败",
    "notifications.successCount": "{count} 张成功",
    "notifications.resultAvailable": "有结果可查看",
    "notifications.failedCount": "{count} 张失败",
    "notifications.systemUnsupported": "当前浏览器不支持系统通知",
    "notifications.systemBlocked": "系统通知已被浏览器阻止，需要在浏览器设置里开启",
    "notifications.systemDenied": "系统通知未开启",
    "notifications.systemEnabled": "系统通知已开启",
    "notifications.taskMissing": "任务不存在或已删除",
    "theme.label": "主题模式",
    "theme.system": "跟随",
    "theme.light": "浅色",
    "theme.dark": "深色",
    "language.label": "界面语言",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "language.vi": "Tiếng Việt",
    "auth.label": "授权来源",
    "auth.checking": "授权检查中",
    "auth.missingCodexSession": "没有检测到 Codex 登录态",
    "auth.switchFailed": "授权来源切换失败",
    "auth.sourceUnavailable": "{source} 不可用",
    "auth.notActive": "未生效",
    "api.settings": "系统设置",
    "api.provider": "API 供应商",
    "imageInput.title": "图像输入",
    "imageInput.uploadAria": "点击、拖入或粘贴图片与文件",
    "imageInput.uploadFull": "点击、拖入或粘贴图片与文件",
    "imageInput.uploadCompact": "添加输入",
    "imageInput.uploadSubtitle": "支持图片与 Responses 参考文件",
    "imageInput.recent": "最近上传",
    "imageInput.recentBadge": "最近",
    "imageInput.uploadBadge": "上传",
    "imageInput.addToGallery": "加入图库",
    "imageInput.addToGalleryShort": "图库",
    "imageInput.removeImage": "移除图片",
    "imageInput.editedBadge": "已编辑",
    "imageInput.editImage": "编辑{name}",
    "imageInput.deletedRecent": "最近上传已删除",
    "imageInput.deletedGallery": "图库图片已删除",
    "recentAssets.defaultName": "最近上传",
    "recentAssets.use": "使用{name}",
    "recentAssets.delete": "删除{name}",
    "recentAssets.deleteTitle": "删除最近上传？",
    "recentAssets.deleteMessage": "会从「最近上传」中删除这张图片。如果它已被添加到当前图像输入，会从当前输入中移除；历史任务里引用这张最近上传图的输入预览也会失效。不会影响公用图库。",
    "recentAssets.loadFailed": "最近上传读取失败",
    "recentAssets.deleteFailed": "最近上传删除失败",
    "recentAssets.deleted": "最近上传已删除",
    "inputSource.uploadFallback": "上传图片",
    "inputSource.galleryFallback": "图库图片",
    "inputSource.focusPasteFallback": "{prefix}，图片输入区已聚焦，请按 {shortcut} 粘贴图片",
    "inputSource.pastedCount": "已粘贴 {count} 张剪贴板图片",
    "inputSource.droppedCount": "已添加 {count} 张拖入图片",
    "inputSource.dropImagesOnly": "只能拖入图片文件",
    "inputSource.clipboardUnsupported": "当前浏览器不支持直接读取剪贴板",
    "inputSource.clipboardEmpty": "没有读到剪贴板图片",
    "inputSource.clipboardDenied": "浏览器拒绝直接读取剪贴板",
    "inputSource.clipboardReadFailed": "无法读取剪贴板",
    "status.missingGalleryReference": "有图库参考图已删除，请移除后再生成",
    "status.missingRecentReference": "有最近上传参考图已删除，请移除后再生成",
    "status.emptyPrompt": "请输入提示词",
    "status.editNeedsImage": "编辑模式至少需要 1 张图片",
    "status.loadedTask": "已载入任务 {taskId}",
    "status.reusedTask": "已在生成页打开任务 {taskId}",
    "status.loadingHistoryInputs": "正在载入历史输入图...",
    "status.historyInputLoadFailed": "无法载入历史输入图: {url}",
    "referenceCollector.alreadyStaged": "已在待加入参考图",
    "referenceCollector.staged": "已暂存 {count} 张参考图",
    "referenceCollector.title": "待加入参考图 · {count} 张",
    "referenceCollector.addAll": "全部加入参考图",
    "referenceCollector.itemFallback": "待加入参考图",
    "referenceCollector.remove": "移除待加入参考图",
    "referenceCollector.cleared": "待加入参考图已清空",
    "referenceCollector.added": "已加入 {count} 张参考图",
    "referenceCollector.addFailed": "待加入参考图加入失败",
    "referenceCollector.readFailed": "图片读取失败：{status}",
    "gallery.quick": "快速选择公用图库",
    "gallery.current": "当前分类图库",
    "gallery.categories": "图库分类",
    "gallery.categoryPortrait": "人像",
    "gallery.categoryCharacter": "角色",
    "gallery.categoryProduct": "产品",
    "gallery.categoryPortraitRole": "人像参考",
    "gallery.categoryCharacterRole": "角色参考",
    "gallery.categoryProductRole": "产品参考",
    "gallery.referenceRole": "参考图",
    "gallery.manage": "管理公用库",
    "gallery.loadFailed": "图库读取失败",
    "gallery.imageOrderUpdateFailed": "更新图片顺序失败",
    "gallery.imageOrderUpdated": "图片顺序已更新",
    "gallery.categoryName": "分类名称",
    "gallery.categoryPromptRole": "提示词用途",
    "gallery.categorySave": "保存",
    "gallery.categoryDelete": "删除",
    "gallery.categoryLoadFailed": "分类读取失败",
    "gallery.categoryNameRequired": "请输入分类名称",
    "gallery.categoryCreateFailed": "新增分类失败",
    "gallery.categoryCreated": "分类已新增",
    "gallery.categorySaveFailed": "保存分类失败",
    "gallery.categorySaved": "分类已保存",
    "gallery.categoryDeleteTitle": "删除图库分类？",
    "gallery.categoryDeleteMessage": "分类下的图片会移动到其他分类，图库图片不会被删除。",
    "gallery.categoryDeleteConfirm": "删除分类",
    "gallery.categoryDeleteFailed": "删除分类失败",
    "gallery.categoryDeletedMigrated": "分类「{name}」已删除，图片已迁移",
    "gallery.categoryOrderUpdateFailed": "更新分类顺序失败",
    "gallery.categoryOrderUpdated": "分类顺序已更新",
    "gallery.categoryFallback": "图库分类",
    "gallery.imageFallback": "图库图片",
    "gallery.imageLoadFailed": "无法载入这张图片",
    "gallery.editImageLoadFailed": "无法载入这张图片进行编辑",
    "gallery.cannotAddImage": "这张图片无法加入图库",
    "gallery.nameRequired": "请输入图库名称",
    "gallery.saveFailed": "保存图库失败",
    "gallery.savedAsReference": "已添加到图库，并切换为图库引用",
    "gallery.renameImage": "重命名图库图片",
    "gallery.moveToCategory": "移动到分类",
    "gallery.categoryRequired": "请选择图库分类",
    "gallery.promptNoteTitle": "图库引用备注",
    "gallery.updateFailed": "更新图库失败",
    "gallery.selectImageFile": "请选择图片文件",
    "gallery.replaceImageFailed": "替换图库图片失败",
    "gallery.replacedImage": "已替换「{name}」的原图",
    "gallery.deleteImageTitle": "删除图库图片？",
    "gallery.deleteImageMessage": "历史任务里的引用会显示为已删除。",
    "gallery.deleteFailed": "删除图库失败",
    "gallery.deletedSuffix": "（已删除）",
    "gallery.editImageLabel": "编辑图库图片",
    "gallery.fieldCategory": "分类",
    "gallery.fieldPromptNote": "引用备注",
    "gallery.fieldName": "名称",
    "quickGallery.empty": "暂无{category}图片",
    "promptGallery.remove": "移除 @{name}",
    "prompt.title": "提示词",
    "prompt.editorLabel": "提示词",
    "prompt.placeholder": "描述你要生成或编辑的图片，输入 @ 可调用图库参考图，输入 # 可插入颜色码，输入 ~ 或 ～ 可调用提示词片段",
    "prompt.run": "开始生成",
    "prompt.runEdit": "开始编辑",
    "prompt.runTitle": "开始生成（Cmd+Enter）",
    "prompt.runEditTitle": "开始编辑（Cmd+Enter）",
    "prompt.findPanel": "查找替换提示词",
    "prompt.findText": "查找文本",
    "prompt.replaceWith": "替换为",
    "prompt.findActions": "查找替换操作",
    "prompt.countZero": "0 处",
    "prompt.matchCount": "{count} 处",
    "prompt.foundCount": "找到 {count} 处",
    "prompt.noMatch": "未找到匹配文本",
    "prompt.replacedCount": "已替换 {count} 处",
    "prompt.closeFind": "关闭查找替换",
    "prompt.recentTemplates": "最近使用模板",
    "prompt.manageTemplates": "管理模板库",
    "promptModel.galleryHeader": "参考图说明：",
    "promptModel.galleryInstruction": "- 参考图 {number}：图库「{name}」，用途：{role}。提示词中的 @{name} 指这张图。{note}",
    "outputSettings.title": "输出设置",
    "output.lock.lock": "锁定参数",
    "output.lock.unlock": "解锁并修改",
    "output.lock.current": "当前锁定",
    "output.lock.task": "所选任务参数",
    "output.lock.adoptTask": "使用此任务参数",
    "output.lock.frame": "画幅",
    "output.lock.outputCount": "输出张数",
    "output.lock.output": "输出",
"output.lock.search": "搜索",
    "output.lock.call": "调用",
    "output.lock.sheets": "张",
    "output.lock.imageModel": "图像模型",
    "output.lock.prompt": "提示词",
    "output.lock.fileFormat": "文件格式",
    "output.lock.taskHint": "仅查看所选任务参数；当前锁定参数保持不变。使用后不改变系统通道。",
    "output.lock.lockedHint": "参数已固定。点击右上角锁图标恢复编辑。",
    "output.lock.enabled": "开启",
    "output.lock.disabled": "关闭",
    "output.lock.custom": "自定义",
    "output.mainModel": "主模型",
    "output.selectMainModel": "选择主模型",
    "output.mainModelCustomForInput": "按当前输入使用自定义模型",
    "output.apiDirect": "API 直连",
    "output.apiToolModel": "使用 API 图像生成模型",
    "output.mainModelUnused": "主模型不参与本次请求",
    "output.webSearch": "联网搜索",
    "output.webSearchToggle": "开启",
    "output.webSearchTitle": "先联网搜索，再用于本次生成；仅 Codex 和 API Responses 支持",
    "output.promptMode": "提示词处理",
    "output.modeOriginal": "原文",
    "output.modeStrict": "保真",
    "output.modeCreative": "自动",
    "output.promptHelp": "查看提示词处理说明",
    "output.promptHelpTitle": "提示词处理",
    "output.promptHelp.responsesChannel": "Responses · 主模型参与",
    "output.promptHelp.imagesChannel": "Images · 直接生成",
    "output.promptHelp.responses.original": "原文交给主模型，并要求图像工具尽量逐字使用；主模型仍可能生成 revised prompt。",
    "output.promptHelp.responses.strict": "允许主模型整理或扩写，但必须保留对象、文字、颜色、构图等硬性约束。",
    "output.promptHelp.responses.automatic": "不添加额外约束，由主模型理解并优化后调用图像工具。",
    "output.promptHelp.images.original": "应用不添加提示词规则，按用户原文直接提交给图像接口。",
    "output.promptHelp.images.strict": "应用将保真规则与原提示词一并提交，强调保留所有硬性约束。",
    "output.promptHelp.images.automatic": "按图像接口默认方式提交；图库引用等必要说明仍会随提示词发送。",
    "output.size": "输出尺寸",
    "output.sizeMode": "尺寸模式",
    "output.sizePreset": "预设尺寸",
    "output.sizeCustom": "自定义尺寸",
    "output.orientation": "方向",
    "output.square": "方形",
    "output.portrait": "竖图",
    "output.landscape": "横图",
    "output.resolution": "分辨率",
    "output.pixelSize": "像素尺寸",
    "output.width": "宽度",
    "output.height": "高度",
    "output.swapSize": "交换宽高",
    "output.customSizeHint": "单位 px · 16-3840 · 16倍数 · ≤3:1",
    "output.imageSizeUnavailable": "图片尺寸不可用",
    "output.imageLoadFailed": "图片加载失败",
    "output.customSizeRequired": "请输入宽度和高度",
    "output.customSizeBounds": "宽高需在 16-3840 px 之间",
    "output.customSizeMultiple": "宽高需为 16 的倍数",
    "output.customSizeRatio": "长短边比例不能超过 3:1",
    "output.customSizePixels": "总像素需在 655,360-8,294,400 之间",
    "output.ratioLock": "比例锁定（可选）",
    "output.customRatio": "自定义宽高比",
    "output.ratioWidth": "宽",
    "output.ratioHeight": "高",
    "output.firstImageRatio": "获取第一张参考图宽高比",
    "output.useFirstImage": "取首图",
    "output.ratioHint": "留空则自由宽高 · 填满后同步",
    "output.ratio": "比例",
    "output.quality": "质量",
    "output.qualityAuto": "自动",
    "output.qualityLow": "低",
    "output.qualityMedium": "中",
    "output.qualityHigh": "高",
    "output.quantity": "数量",
    "output.pixelPreview": "输出像素: 1024 x 1024 px",
    "output.pixelPreviewValue": "输出像素: {value}",
    "output.pixelPreviewAuto": "输出像素: auto（OpenAI 自动选择）",
    "output.format": "输出格式",
    "output.compression": "压缩率",
    "output.moderation": "审核",
    "preview.title": "预览结果",
    "preview.selectedZero": "已选 0",
    "preview.selectedCount": "已选 {selected}/{total}",
    "preview.downloadSelected": "只下载精选",
    "preview.deleteUnselected": "删除未精选",
    "preview.downloadAll": "打包下载",
    "preview.empty": "暂无图片",
    "preview.taskFailed": "任务失败",
    "preview.partialFailed": "部分图片生成失败",
    "preview.failedOutput": "第 {index} 张失败",
    "preview.progressLine": "已完成 {generated} / {total} · 计时 {elapsed}",
    "preview.failureLine": "已完成 {generated} / {total} · 失败 {failed}",
    "preview.elapsedLine": "计时 {elapsed}",
    "preview.lastError": "上次错误：{error}",
    "preview.continueGenerating": "继续生成中",
    "preview.waitingContinue": "等待继续生成",
    "preview.retryFailed": "仅重试失败图片",
    "preview.acceptSuccesses": "接受已成功结果",
    "preview.generateMode": "生成",
    "preview.editMode": "编辑",
    "preview.runningTitle": "{mode}任务运行中",
    "preview.submittingTitle": "提交任务中",
    "preview.queuedTitle": "任务排队中",
    "preview.submittingDetail": "正在保存输入并写入队列，完成后会自动进入生成流程。",
    "preview.queuedDetail": "任务已进入队列，等待可用通道接手。",
    "preview.featured": "精选",
    "preview.addFeatured": "加入精选",
    "preview.selectedFeatured": "已精选",
    "preview.removeFeatured": "取消精选",
    "preview.selectionAdded": "已加入精选",
    "preview.selectionRemoved": "已取消精选",
    "preview.selectionUpdateFailed": "精选状态更新失败",
    "preview.noUnselectedOutputs": "没有可删除的未精选图片",
    "preview.deleteUnselectedTitle": "删除未精选图片？",
    "preview.deleteUnselectedMessage": "会删除当前任务里未精选的本地图片文件。",
    "preview.deleteUnselectedDetail": "保留 {selected} 张，删除 {deleted} 张",
    "preview.deleteUnselectedFailed": "删除未精选失败",
    "preview.deleteUnselectedDone": "未精选图片已删除",
    "preview.addReference": "加入参考图",
    "preview.stage": "暂存",
    "preview.stageReference": "暂存到待加入参考图",
    "preview.prompt": "提示词",
    "preview.download": "下载",
    "preview.downloadImage": "下载该图片",
    "lightbox.label": "图片预览",
    "lightbox.close": "关闭预览",
    "lightbox.previous": "上一张",
    "lightbox.next": "下一张",
    "promptPopover.title": "提示词对比",
    "promptPopover.summary": "原始 {original} · 优化 {optimized}",
    "promptPopover.original": "原始提示词",
    "promptPopover.optimized": "优化后提示词",
    "promptPopover.charCount": "{count} 字",
    "promptPopover.empty": "无",
    "promptPopover.notReturned": "未返回",
    "promptPopover.noOptimized": "未返回优化提示词",
    "promptPopover.submitted": "查看实际提交提示词",
    "promptPopover.close": "关闭提示词",
    "promptPopover.copyOptimized": "复制优化后提示词",
    "promptPopover.copied": "已复制",
    "taskContext.menuLabel": "任务右键菜单",
    "taskContext.view": "查看任务",
    "taskContext.copyId": "复制任务 ID",
    "taskContext.copyPrompt": "复制提示词",
    "taskContext.revealOutput": "打开输出目录",
    "taskContext.archive": "归档任务",
    "taskContext.delete": "删除任务",
    "taskContext.idCopied": "任务 ID 已复制",
    "taskContext.promptCopied": "提示词已复制",
    "taskContext.noPrompt": "这个任务没有可复制的提示词",
    "taskContext.revealFailed": "打开输出目录失败",
    "taskContext.revealOpened": "已打开输出目录",
    "taskContext.actionFailed": "任务操作失败",
    "taskActions.group": "任务操作",
    "taskActions.deleteTitle": "删除任务？",
    "taskActions.deleteMessage": "会同时删除本地图片文件。",
    "taskActions.runningCannotDelete": "运行中的任务不能删除",
    "taskActions.updated": "任务状态已更新",
    "taskActions.archived": "会话已归档",
    "taskActions.archiveFailed": "归档失败",
    "taskActions.deleted": "任务已删除",
    "taskActions.deleteFailed": "删除失败",
    "taskActions.noRetryableFailedImages": "这个任务没有可重试的失败图片",
    "taskActions.retryFailedOutputsFailed": "重试失败图片失败",
    "taskActions.requeuedFailedImages": "已重新入队失败图片",
    "taskActions.noAcceptableSuccessImages": "这个任务没有可接受的成功图片",
    "taskActions.acceptSuccessesFailed": "接受成功结果失败",
    "taskActions.acceptedSuccesses": "已接受成功结果",
    "taskActions.viewedUpdateFailed": "已读状态更新失败",
    "taskActions.failedFallback": "任务失败",
    "taskList.empty": "暂无历史任务",
    "taskList.selectSession": "选择会话",
    "taskList.unreadUpdate": "未读更新",
    "taskList.viewing": "查看中",
    "taskList.backToLatest": "回到最新任务",
    "taskList.backToLatestWithCount": "回到最新任务，上方有 {count} 个新任务",
    "taskDerived.usageLimited": "用量受限",
    "taskSubmit.requestFailed": "请求失败",
    "taskSubmit.queued": "任务已加入队列",
    "taskSubmit.timeout": "提交任务超时，后端没有及时返回。请刷新队列后确认是否已入队，再决定是否重试。",
    "taskSubmit.failed": "任务提交失败",
    "templates.title": "提示词模板",
    "templates.summary": "本地模板库",
    "templates.availableCount": "{count} 个可用模板",
    "templates.noMatch": "暂无匹配模板",
    "templates.empty": "暂无模板",
    "templates.favoriteBadge": "已收藏",
    "templates.usageCount": "{count} 次",
    "templates.back": "返回",
    "templates.edit": "编辑",
    "templates.copy": "复制",
    "templates.insert": "插入",
    "templates.formTitle": "标题",
    "templates.formShortTitle": "短标题",
    "templates.formCategory": "分类",
    "templates.formTags": "标签",
    "templates.formThumbnail": "缩略图",
    "templates.formContent": "内容",
    "templates.formNotes": "备注",
    "templates.formFavorite": "收藏",
    "templates.thumbnailClear": "清除",
    "templates.thumbnailNone": "未选择",
    "templates.thumbnailEmpty": "暂无历史缩略图",
    "templates.newCategory": "新分类",
    "templates.search": "搜索模板、标签、内容",
    "templates.filter": "模板筛选",
    "templates.all": "全部",
    "templates.categoryCommon": "常用",
    "templates.categoryPortrait": "人像",
    "templates.categoryProduct": "产品",
    "templates.categoryRepair": "修复",
    "templates.categoryPoster": "海报",
    "templates.categoryEcommerce": "电商",
    "templates.favorite": "收藏",
    "templates.recent": "最近",
    "templates.category": "分类",
    "templates.loadFailed": "提示词模板读取失败",
    "templates.useStateUpdateFailed": "提示词模板使用状态更新失败",
    "templates.copied": "提示词模板已复制",
    "templates.copyFailed": "提示词模板复制失败",
    "templates.history": "历史记录",
    "templates.saveFailed": "提示词模板保存失败",
    "templates.saved": "提示词模板已保存",
    "templates.deleteFailed": "提示词模板删除失败",
    "templates.deleted": "提示词模板已删除",
    "templates.categoryAddFailed": "模板分类添加失败",
    "templates.categoryAdded": "模板分类已添加",
    "templates.categorySaveFailed": "模板分类保存失败",
    "templates.categorySaved": "模板分类已保存",
    "templates.categoryDeleteFailed": "模板分类删除失败",
    "templates.categoryDeleted": "模板分类已删除",
    "templates.importFailed": "模板包导入失败",
    "templates.importedCount": "已导入 {count} 个模板",
    "templates.exportFailed": "模板包导出失败",
    "templates.exported": "模板包已导出",
    "snippets.suggestLabel": "提示词片段选择器",
    "snippets.saveSelection": "收藏",
    "snippets.saveSelectionLabel": "收藏选中的提示词片段",
    "snippets.popoverLabel": "提示词片段",
    "snippets.defaultCategory": "常用",
    "snippets.loadFailed": "提示词片段读取失败",
    "snippets.remove": "移除 ~{tag}",
    "snippets.expand": "展开",
    "snippets.edit": "编辑",
    "snippets.close": "关闭",
    "snippets.editTitle": "编辑片段",
    "snippets.saveTitle": "收藏片段",
    "snippets.shortTag": "短标签",
    "snippets.title": "标题",
    "snippets.category": "分类",
    "snippets.content": "内容",
    "snippets.titlePlaceholder": "默认使用短标签",
    "snippets.cancel": "取消",
    "snippets.save": "保存",
    "snippets.saveFailed": "提示词片段保存失败",
    "snippets.saved": "提示词片段已保存",
    "snippets.defaultTag": "常用片段",
    "colors.white": "白色",
    "colors.black": "黑色",
    "colors.warmBeige": "暖米色",
    "colors.lightGreen": "浅绿",
    "colors.brandGreen": "品牌绿",
    "colors.peachOrange": "桃橙",
    "colors.lightBlue": "浅蓝",
    "colors.lightPink": "浅粉",
    "colors.loadFailed": "颜色配置读取失败",
    "colors.saveFailed": "颜色配置保存失败",
    "colors.importFailed": "颜色配置导入失败",
    "colors.importedCount": "已导入 {count} 个颜色",
    "colors.recentSaveFailed": "最近颜色保存失败",
    "colors.favoriteSaveFailed": "常用颜色保存失败",
    "colors.favoriteDeleteFailed": "常用颜色删除失败",
    "colors.update": "更新",
    "colors.insert": "插入",
    "colors.pick": "选择颜色",
    "colors.pickShort": "取色",
    "colors.hexValue": "颜色值",
    "colors.pendingUpdate": "颜色已修改，点击更新生效",
    "colors.save": "保存",
    "colors.exportPs": "导出",
    "colors.importPs": "导入",
    "colors.done": "完成",
    "colors.manage": "管理",
    "colors.favorites": "常用颜色",
    "colors.recent": "最近颜色",
    "colors.recentLabel": "最近",
    "colors.deleteFavorite": "删除常用色 {name}",
    "colors.modify": "修改颜色",
    "colors.modifyValue": "修改颜色 {value}",
    "colors.removeValue": "移除颜色 {value}",
    "taskGroup.today": "今天",
    "taskGroup.yesterday": "昨天",
    "taskGroup.last7": "最近 7 天",
    "taskGroup.older": "更早",
    "taskGroup.searchResults": "搜索结果",
    "taskGroup.active": "活动任务",
    "taskGroup.running": "运行中",
    "taskGroup.waiting": "等待中",
    "taskGroup.dispatchPending": "正在分配可用通道...",
    "taskGroup.expand": "展开 {label}",
    "taskGroup.collapse": "收起 {label}",
    "taskGroup.buttonLabel": "{label}，{count} 个任务",
    "taskGroup.loadMore": "再加载 {count} 条",
    "archive.title": "会话归档",
    "archive.empty": "暂无归档会话",
    "archive.count": "{count} 个归档会话",
    "archive.restore": "恢复",
    "archive.archiveFailed": "归档失败",
    "archive.restoreFailed": "恢复失败",
    "archive.restored": "会话已恢复",
    "archive.archiving": "正在归档...",
    "archive.restoring": "正在恢复...",
    "archive.deleting": "正在删除...",
    "archive.restoredCount": "已恢复 {count} 个任务",
    "settings.title": "存储设置",
    "settings.status": "保存存储路径后重启 WebUI 生效",
    "settings.inputRoot": "输入目录",
    "settings.outputRoot": "输出目录",
    "settings.galleryRoot": "公用图库目录",
    "settings.sourceDataRoot": "源数据目录",
    "settings.language": "界面语言",
    "settings.languageCopy": "首次启动会自动跟随浏览器语言，手动选择后会记住偏好。",
    "settings.notificationsCopy": "任务完成或失败时提醒，系统通知需手动开启。",
    "settings.inAppNotification": "站内通知",
    "settings.systemNotification": "系统通知",
    "settings.save": "保存设置",
    "settings.loadFailed": "设置读取失败",
    "settings.saveFailed": "设置保存失败",
    "settings.savedRestart": "存储设置已保存，重启 WebUI 后生效",
    "settings.saved": "已保存",
    "settings.savedRestartStatus": "存储设置已保存，重启 WebUI 后生效",
    "systemSettings.title": "系统设置",
    "systemSettings.tabsLabel": "系统设置选项",
    "systemSettings.apiTab": "API 设置",
    "systemSettings.codexTab": "Codex 通道",
    "systemSettings.languageTab": "语言 / Language",
    "systemSettings.storageTab": "存储与通知",
    "systemSettings.networkTab": "网络",
    "networkEgress.mode": "网络出口",
    "networkEgress.system": "系统",
    "networkEgress.direct": "直连",
    "networkEgress.custom": "自定义",
    "networkEgress.customProxy": "自定义代理地址",
    "networkEgress.currentRoute": "当前出口：{route}",
    "networkEgress.test": "检测连接",
    "networkEgress.save": "保存并应用",
    "networkEgress.saved": "网络出口已保存",
    "networkEgress.testSucceeded": "连接成功：{target}（{elapsed} 毫秒）",
    "networkEgress.testFailed": "连接检测失败",
    "networkEgress.loadFailed": "网络设置加载失败",
    "networkEgress.saveFailed": "网络设置保存失败",
    "languageSettings.instantStatus": "语言切换后立即生效",
    "apiSettings.title": "API 设置",
    "apiSettings.status": "保存后立即用于 API 模式",
    "apiSettings.codexMode": "Codex 通道",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API 供应商",
    "apiSettings.searchProviders": "搜索供应商名称",
    "apiSettings.noProviderSearchResults": "未找到匹配的供应商",
    "apiSettings.providerCount": "{count} 个供应商",
    "apiSettings.provider": "供应商",
    "apiSettings.providerName": "供应商名称",
    "apiSettings.providerIcon": "Emoji 图标",
    "apiSettings.providerIconPlaceholder": "可选，例如 🪄",
    "apiSettings.connectionScope": "连接级设置",
    "apiSettings.connectionPreview": "连接预览",
    "apiSettings.modelBindings": "模型绑定",
    "apiSettings.modelBindingsHint": "一个供应商可同时绑定多个型号和协议。",
    "apiSettings.addModelBinding": "添加模型绑定",
    "apiSettings.appendRatioPrompt": "追加比例提示",
    "apiSettings.defaultProviderForModel": "设为默认供应商",
    "apiSettings.removeBinding": "删除绑定",
    "apiSettings.catalogRequiredForBinding": "模型目录不可用，暂时无法添加绑定",
    "apiSettings.keepOneBinding": "每个供应商至少保留一条模型绑定",
    "apiSettings.bindingRequiredFields": "请为每条绑定选择型号、填写远端模型名并至少选择一个操作",
    "apiSettings.bindingOverlap": "{model} 的 {operation} 操作被多条绑定重复处理",
    "apiSettings.actualRequest": "实际请求",
    "apiSettings.newProviderAction": "新建供应商",
    "apiSettings.copyProvider": "复制",
    "apiSettings.copyProviderName": "{name} 副本",
    "apiSettings.copyProviderStatus": "已复制配置和已保存 Key，可修改名称、模型或替换 Key 后保存",
    "apiSettings.copyProviderWithoutKeyStatus": "已复制配置，可修改名称、模型或填写 API Key 后保存",
    "apiSettings.sortProviders": "排序",
    "apiSettings.finishSortProviders": "完成",
    "apiSettings.sortProviderModeStatus": "正在排序供应商",
    "apiSettings.sortProviderStatus": "供应商排序已调整，正在自动保存",
    "apiSettings.moveProviderUp": "上移",
    "apiSettings.moveProviderDown": "下移",
    "apiSettings.moveProviderUpAria": "上移 {provider}",
    "apiSettings.moveProviderDownAria": "下移 {provider}",
    "apiSettings.mode": "调用方式",
    "apiSettings.images": "直连 Image API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "直连",
    "apiSettings.imageModel": "图像生成模型",
    "apiSettings.concurrency": "并发上限",
    "apiSettings.concurrencyShort": "并发",
    "apiSettings.advancedSettings": "高级设置",
    "apiSettings.concurrencyValue": "并发 {concurrency}",
    "apiSettings.keySaved": "已保存 API Key",
    "apiSettings.keyNotSet": "未设置 API Key",
    "apiSettings.showApiKey": "显示 API Key",
    "apiSettings.hideApiKey": "隐藏 API Key",
    "apiSettings.editProvider": "编辑供应商",
    "apiSettings.newProviderTitle": "新增供应商",
    "apiSettings.editHint": "点击保存供应商后写入后端，取消可放弃本次编辑。",
    "apiSettings.finishEditFirst": "请先保存或取消当前供应商编辑",
    "apiSettings.newDraftStatus": "正在新增供应商，保存供应商后生效",
    "apiSettings.editDraftStatus": "正在编辑供应商，保存供应商后生效",
    "apiSettings.cancelEdit": "取消编辑",
    "apiSettings.saveProvider": "保存供应商",
    "apiSettings.saveSelection": "保存当前选择",
    "apiSettings.deleteProviderTitle": "删除供应商？",
    "apiSettings.deleteProviderMessage": "确定删除「{provider}」？",
    "apiSettings.deleteProviderDetail": "会从当前供应商列表移除，并自动保存到后端。",
    "apiSettings.deleteProviderStatus": "已删除供应商，正在自动保存",
    "apiSettings.save": "保存 API 设置",
    "apiSettings.loadFailed": "API 设置读取失败",
    "apiSettings.savedKeyPlaceholder": "后端已保存 API Key，输入新 key 可覆盖",
    "apiSettings.newProvider": "新供应商",
    "apiSettings.saving": "保存中...",
    "apiSettings.savingStatus": "正在保存 API 设置...",
    "apiSettings.autoSaving": "正在自动保存...",
    "apiSettings.autoSaved": "已自动保存",
    "apiSettings.saveFailed": "API 设置保存失败",
    "apiSettings.savedSummary": "已保存 · Codex {codex} · API {provider} · {mode} · {model} · 并发 {concurrency}",
    "apiSettings.savedShort": "已保存",
    "apiSettings.savedStatus": "API 设置已保存",
    "apiSettings.saveFailedShort": "保存失败",
    "codexSettings.title": "Codex 通道",
    "codexSettings.status": "选择 Codex 本机登录态使用的生成通道",
    "codexSettings.notesLabel": "Codex 通道说明",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "默认通道，尺寸、质量和编辑参数直传，适合常规生成和编辑。",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "兼容通道，用于需要联网搜索或 Responses 工具链的任务。",
    "codexSettings.current": "当前使用",
    "codexSettings.save": "保存 Codex 通道",
    "codexSettings.saveMode": "保存 {mode}",
    "imageEditor.title": "编辑输入图片",
    "imageEditor.promptHint": "图中的手绘箭头和标记仅用于指示编辑要求，不要保留在最终画面中。",
    "imageEditor.inputFallback": "输入图片",
    "imageEditor.openFailed": "无法打开这张图片进行编辑",
    "imageEditor.loadForEditFailed": "无法载入这张图片进行编辑",
    "imageEditor.canvasCreateFailed": "无法创建图片编辑画布",
    "imageEditor.closedRegionRequired": "请先用画笔圈出封闭区域",
    "imageEditor.saveFailed": "图片编辑保存失败",
    "imageEditor.saved": "已保存编辑后的输入图",
    "imageEditor.uneditable": "这张图片无法编辑",
    "imageEditor.resetDone": "已重置到原图",
    "imageEditor.resetFailed": "无法重置原图",
    "imageEditor.subtitle": "裁剪、涂鸦、油漆桶填充或添加箭头后保存为新的输入图",
    "imageEditor.toolbar": "图片编辑工具栏",
    "imageEditor.tools": "工具",
    "imageEditor.select": "选择",
    "imageEditor.brush": "画笔",
    "imageEditor.arrow": "箭头",
    "imageEditor.crop": "裁剪",
    "imageEditor.fill": "油漆桶",
    "imageEditor.fillLabel": "油漆桶填充",
    "imageEditor.eraser": "擦除",
    "imageEditor.colors": "颜色",
    "imageEditor.red": "红色",
    "imageEditor.blue": "蓝色",
    "imageEditor.green": "绿色",
    "imageEditor.yellow": "黄色",
    "imageEditor.white": "白色",
    "imageEditor.black": "黑色",
    "imageEditor.customColor": "自定义颜色",
    "imageEditor.stroke": "粗细",
    "imageEditor.history": "历史",
    "imageEditor.undo": "撤销",
    "imageEditor.redo": "重做",
    "imageEditor.reset": "重置原图",
    "imageEditor.canvas": "图片编辑画布",
    "imageEditor.canvasScope": "画布范围",
    "imageEditor.canvasScopeBase": "首图",
    "imageEditor.canvasScopeFit": "适应图层",
    "imageEditor.canvasFitDone": "画布已适应图层范围",
    "imageEditor.canvasBaseDone": "画布已恢复首图范围",
    "imageEditor.insertImages": "插入图片",
    "imageEditor.layers": "图层",
    "imageEditor.layerUp": "上移",
    "imageEditor.layerDown": "下移",
    "imageEditor.emptyInsertList": "暂无其他输入图",
    "imageEditor.selectLayerFirst": "请先选择图层",
    "imageEditor.baseLayer": "原图",
    "gallery.title": "公用图库",
    "gallery.subtitle": "选择参考图加入当前任务",
    "gallery.manageCategories": "管理分类",
    "gallery.categoryManager": "管理图库分类",
    "gallery.categoryManagement": "分类管理",
    "gallery.categoryCopy": "分类会保存到图库；提示词用途用于生成参考图说明",
    "gallery.newCategoryName": "新分类名称",
    "gallery.newCategoryRole": "提示词用途，例如：风格参考",
    "gallery.addCategory": "新增分类",
    "gallery.drawerSubtitle": "当前分类：{category}，点击“使用”加入图像输入",
    "gallery.emptyCategory": "这个分类还没有图片",
    "gallery.dragSort": "拖拽排序",
    "gallery.dragSortImage": "拖拽排序图片 {name}",
    "gallery.dragSortCategory": "拖拽排序分类 {name}",
    "gallery.use": "使用",
    "gallery.replace": "替换",
    "gallery.rename": "重命名",
    "gallery.moveCategory": "分类",
    "gallery.note": "备注",
    "gallery.delete": "删除",
    "gallery.uncategorized": "未分类",
    "addGallery.title": "添加到图库",
    "addGallery.copy": "名称全局唯一，后续可用 @名称 调取",
    "addGallery.name": "名称",
    "addGallery.namePlaceholder": "例如：小美",
    "addGallery.category": "分类",
    "addGallery.note": "引用备注",
    "addGallery.notePlaceholder": "例如：只参考脸型和发型，不参考衣服和背景",
    "addGallery.save": "保存到图库",
    "close.promptTemplates": "关闭提示词模板面板",
    "close.archive": "关闭会话归档面板",
    "close.settings": "关闭存储设置面板",
    "close.apiSettings": "关闭 API 设置面板",
    "close.systemSettings": "关闭系统设置面板",
    "close.imageEditor": "关闭编辑输入图片面板",
    "close.gallery": "关闭公用图库面板",
    "close.addGallery": "关闭添加到图库面板",
    "close.version": "关闭版本更新面板",
    "imageInput.referenceTitle": "参考输入（可选）",
    "referenceFiles.add": "添加文件",
    "referenceFiles.selected": "参考文件",
    "referenceFiles.recent": "最近文件",
    "referenceFiles.familyPdf": "页面 + 文本",
    "referenceFiles.familySpreadsheet": "表格",
    "referenceFiles.familyDocument": "文档",
    "referenceFiles.familyText": "文本",
    "referenceFiles.visualLimit": "非 PDF 文件不会保留内嵌图片和图表；需要版式参考时请先转为 PDF。",
    "referenceFiles.remove": "移除文件 {filename}",
    "referenceFiles.switchTitle": "移除参考文件？",
    "referenceFiles.switchMessage": "参考文件仅支持 Responses，切换到 Images 前需要移除已选文件。",
    "referenceFiles.removeAndSwitch": "移除文件并切换",
    "referenceFiles.requiresResponses": "参考文件仅支持 Responses",
    "referenceFiles.switchToResponses": "切换到 Responses",
    "referenceFiles.openApiSettings": "打开 API 设置",
    "referenceFiles.providerMissing": "原任务使用的 Responses 供应商不可用，请在 API 设置中选择。",
    "referenceFiles.missing": "文件已缺失",
    "referenceFiles.loadFailed": "参考文件载入失败",
    "referenceFiles.errorEmpty": "参考文件为空",
    "referenceFiles.errorUnsupported": "不支持这种参考文件格式",
    "referenceFiles.errorMismatch": "文件内容与扩展名不匹配",
    "referenceFiles.errorInvalid": "参考文件无效",
    "referenceFiles.errorTooLarge": "单个参考文件必须小于 50 MB",
    "referenceFiles.errorTotalTooLarge": "参考文件总大小不能超过 50 MB",
    "referenceFiles.errorMissing": "选中的参考文件已缺失",
    "referenceFiles.errorProviderUnsupported": "当前供应商的 Responses 不支持参考文件",
    "referenceFiles.responsesEnabled": "已切换到 Responses",
    "referenceFiles.historyPathMismatch": "这些参考文件使用了不同的 Responses 路径",
    "history.referenceFiles": "参考文件",
    "history.downloadReferenceFile": "下载文件",
    "history.readdReferenceFile": "重新加入",
    "modelSelection.family": "模型系列",
    "modelSelection.concreteModel": "具体型号",
    "modelSelection.provider": "供应商",
    "modelSelection.providerUnavailable": "当前型号没有可用供应商",
    "modelSelection.openSettings": "打开供应商设置",
    "modelSelection.codexUnavailable": "Codex 登录不可用",
    "modelSelection.catalogUnavailable": "模型目录不可用",
    "output.background": "背景",
    "canvas.aspectRatio": "画面比例",
    "canvas.resolution": "分辨率",
    "gemini.googleSearch": "Google 搜索",
    "gemini.googleImageSearch": "Google 图片搜索",
    "output.modalities": "输出模态",
    "gemini.safetySettings": "安全设置",
    "gemini.safety.harassment": "骚扰",
    "gemini.safety.hateSpeech": "仇恨言论",
    "gemini.safety.sexuallyExplicit": "色情露骨内容",
    "gemini.safety.dangerousContent": "危险内容",
    "gemini.safety.threshold.unspecified": "默认",
    "gemini.safety.threshold.off": "关闭过滤",
    "gemini.safety.threshold.blockNone": "不拦截",
    "gemini.safety.threshold.blockOnlyHigh": "拦截高危",
    "gemini.safety.threshold.blockMediumAndAbove": "拦截中高",
    "gemini.safety.threshold.blockLowAndAbove": "拦截全部",
    "grounding.title": "Google 搜索来源",
    "grounding.searchSuggestions": "Google 搜索建议",
    "grounding.sourceCount": "{count} 个来源",
    "grounding.source": "来源 {index}",
    "modelParameters.invalidValue": "参数值无效",
    "modelParameters.objectRequired": "请输入 JSON 对象",
    "modelParameters.invalidJson": "JSON 格式无效",
    "modelParameters.migrated": "已按当前模型兼容 {count} 个旧参数",
    "modelParameters.historyConfiguration": "历史配置",
    "modelParameters.legacyTask": "旧版任务",
};
